<template>
  <div id="app">
    <hello></hello>
  </div>
</template>

<script>
import Hello from './components/Hello'

export default {
  name: 'app',
  components: {
    Hello
  }
}
</script>

<style>
  body {
    margin: 0px;
    padding: 0px;;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
  /* Black = fgt5
  Book = evj34
  Heavy = dveve53
  */

  @font-face {
    font-family: Fgt5;
    src: url('./assets/fonts/Fgt5.woff');
  }

  @font-face {
    font-family: Evj34;
    src: url('./assets/fonts/Evj34.woff');
  }

  @font-face {
    font-family: Dveve53;
    src: url('./assets/fonts/Dveve53.woff');
  }

  p {
    font-family: "Evj34";
  }

  h1 {
    font-family: "Dveve53", Times;
    margin-top: 0;
    padding-top: 3vh;
    font-size: 1.35em;
    text-align: center;
    color: rgba(72, 255, 0, 1);
  }
  h2 {
    position:absolute;
    font-family: "Fgt5", Times;
    top:50%;
    letter-spacing: 1px;
    margin-top: -1.3em;
    margin-left: 5%;
    width: 90%;
    font-size: 0.6em;
    text-transform: uppercase;
    text-align: center;
    color: white;

  }

  h3 {
    font-family: "Fgt5", Times;
    text-align: center;
    font-size: 1.5em;
    margin: 0 auto 0.5em auto;
    color: rgba(72, 255, 0, 1);
  }

  .after {
    clear:left;
  }

  /* main section */
  .main {
    text-align: center;
    margin-bottom: 1em;
    padding-bottom: 1em;
    display: inline-block;
    min-height: 100vh;
    min-width: 100vw;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 1) 100%), url("./assets/berlin_grid_norm.jpg");
    background-position: top right;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .main > .content-div {
    position: relative;
    lost-center: 90vw;
    max-height: 60vh;
  }
  .board {
    /*noinspection CssUnknownProperty*/
    lost-center: 90%;
    display: block;
    margin-top: 5vh;
  }

  .tile {
    lost-column: 1/2;
    margin-bottom: 1em;
    display: block;
  }
  svg {
    position: relative;
    display: block;
    margin-bottom: 5px;
    width: 100%;
    max-height: 6em;
    padding: 0;
    background-color: rgba(72, 255, 0, 0.8);

  }
  .board .tile div {
    position: relative;
    min-height: 2.9em;
    background-color: rgba(72, 255, 0, 0.8);
    text-align: center;
  }
  .tile:hover {

  h2, svg, div {
    background-color: rgba(72, 255, 0, 1);
    -webkit-backface-visibility: hidden;
  }

  }

  /* Partners */
  #partners {
    margin-top: 2em;
    padding-top: 1em;
    text-align: center;
    lost-center: 90%;
  }

  .partners {
    display: block;
    lost-center: 80%;
    margin-top: 2em;

  }

  .partners a {
    display: block;
    lost-column: 1/3;

  }
  a {
    text-decoration: none;
    color: black;
  }

  /* Footer */
  footer {
    text-align: center;
    margin: 5% auto 2em auto;

  ul {
    display: inline-block;
    margin: 0;
    padding: 0;

  li {
    display: inline;
    text-decoration: none;
    margin: 1.5em;
  }
  a {
    color: gray;
    font-family: Fgt5!important;
  }
  a:hover {
    color: black;
  }

  }
  }
  .big {
    font-family: Fgt5;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// App.vue?45d37fec